<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Mark As Completed" />
         
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">

                            <div class="row mb-3">
                                <div class="col-12">
                                    <a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                                </div>
                            </div>

                            <form @submit.prevent="submitCompletion" enctype="multipart/form-data">
                                <div class="row">
                                    <!-- Technician -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Technician<span class="text-danger">*</span></label>
                                        <select 
                                            class="form-select" 
                                            v-model="formData.technician_id" 
                                            required
                                        >
                                            <option value="">--Select Technician--</option>
                                            <option 
                                                v-for="technician in technicians" 
                                                :key="technician.id" 
                                                :value="technician.id"
                                            >
                                                {{ technician.name }}
                                            </option>
                                        </select>
                                        <span class="validate-error" v-if="errors.technician_id">
                                            {{ errors.technician_id[0] }}
                                        </span>
                                    </div>

                                    <!-- Dealer -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Dealer<span class="text-danger">*</span></label>
                                        <div class="position-relative dealer-dropdown">
                                            <input
                                                class="form-control"
                                                type="text"
                                                placeholder="Search Dealer"
                                                v-model="dealer_search"
                                                :disabled="isDealerProfileLocked"
                                                @input="handleDealerSearch"
                                                @focus="showDealerSuggestions = true"
                                                @blur="handleDealerInputBlur"
                                                v-bind:class="{ 'is-invalid': Boolean(errors.dealer_id) }"
                                            />
                                            <ul
                                                v-if="showDealerSuggestions && filteredDealerList.length"
                                                class="list-group position-absolute"
                                                style="width:100%; z-index: 9999; max-height: 200px; overflow-y: auto;"
                                                ref="dealerSuggestionList"
                                            >
                                                <li
                                                    v-for="dealer in filteredDealerList"
                                                    :key="dealer.id"
                                                    class="list-group-item list-group-item-action"
                                                    @mousedown.prevent="setDealer(dealer)"
                                                >
                                                    {{ dealer.first_name }}
                                                </li>
                                            </ul>
                                        </div>
                                        <span class="validate-error" v-if="errors.dealer_id">
                                            {{ errors.dealer_id[0] }}
                                        </span>
                                    </div>

                                    <!-- Vehicle Number -->
                                    <div class="col-md-12 form-group mb-3">
                                        <label class="control-label">Vehicle Number<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="text" 
                                            v-model="formData.vehicle_no" 
                                            placeholder="Enter vehicle number" 
                                            required 
                                        />
                                        <span class="validate-error" v-if="errors.vehicle_no">
                                            {{ errors.vehicle_no[0] }}
                                        </span>
                                    </div>

                                    <!-- Engine Number -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Engine Number</label>
                                        <input 
                                            class="form-control" 
                                            type="text" 
                                            v-model="formData.engine_no" 
                                            placeholder="Enter engine number" 
                                        />
                                    </div>

                                    <!-- Chassis Number -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Chassis Number</label>
                                        <input 
                                            class="form-control" 
                                            type="text" 
                                            v-model="formData.chassis_no" 
                                            placeholder="Enter chassis number" 
                                        />
                                    </div>

                                    <!-- Vehicle Make -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Vehicle Make</label>
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="formData.vehicle_make"
                                            placeholder="Enter vehicle make"
                                        />
                                        <span class="validate-error" v-if="errors.vehicle_make">
                                            {{ errors.vehicle_make[0] }}
                                        </span>
                                    </div>

                                    <!-- Vehicle Model -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Vehicle Model</label>
                                        <input
                                            class="form-control"
                                            type="text"
                                            v-model="formData.vehicle_model"
                                            placeholder="Enter vehicle model"
                                        />
                                        <span class="validate-error" v-if="errors.vehicle_model">
                                            {{ errors.vehicle_model[0] }}
                                        </span>
                                    </div>

                                    <!-- Registration Date -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Registration Date</label>
                                        <input
                                            class="form-control"
                                            type="date"
                                            v-model="formData.registration_date"
                                        />
                                        <span class="validate-error" v-if="errors.registration_date">
                                            {{ errors.registration_date[0] }}
                                        </span>
                                    </div>

                                    <!-- IMEI Field (for product_id = 1 and service_type = 1) -->
                                    <div class="col-md-12 form-group mb-3" v-if="showImeiField">
                                        <label v-if="job.service_type == 3" class="control-label">New Device IMEI<span class="text-danger">*</span></label>
                                        <label v-else class="control-label">IMEI<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="text" 
                                            v-model="formData.imei" 
                                            placeholder="Enter IMEI number" 
                                             
                                        />
                                        <span class="validate-error" v-if="errors.imei">
                                            {{ errors.imei[0] }}
                                        </span>
                                    </div>

                                    <!-- Serial: dealer (role 3) + camera uses search list; else manual when showSerialNumberField -->
                                    <div class="col-md-12 form-group mb-3" v-if="showSerialNumberField && useDealerCameraSerialPicker">
                                        <label class="control-label">Serial Number<span class="text-danger">*</span></label>
                                        <div class="position-relative dealer-camera-dropdown">
                                            <input
                                                class="form-control"
                                                type="text"
                                                placeholder="Search serial number and select a row"
                                                v-model="formData.device_serial_no"
                                                @input="onDealerCameraSerialInput"
                                                @focus="onDealerCameraSerialFocus"
                                                @blur="onDealerCameraSerialBlur"
                                                v-bind:class="{ 'is-invalid': Boolean(errors.device_serial_no) }"
                                            />
                                            <ul
                                                v-if="showDealerCameraSuggestions && filteredDealerCameras.length"
                                                class="list-group position-absolute w-100"
                                                style="z-index: 9999; max-height: 220px; overflow-y: auto"
                                            >
                                                <li
                                                    v-for="row in filteredDealerCameras"
                                                    :key="row.id"
                                                    class="list-group-item list-group-item-action"
                                                    @mousedown.prevent="selectDealerCamera(row)"
                                                >
                                                    <span class="fw-semibold">{{ row.serial_number }}</span>
                                                    <span class="text-muted ms-2">{{ getDealerCameraNameFromRow(row) }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <span class="validate-error" v-if="errors.device_serial_no">
                                            {{ errors.device_serial_no[0] }}
                                        </span>
                                    </div>
                                    <div class="col-md-12 form-group mb-3" v-else-if="showSerialNumberField">
                                        <label class="control-label">Serial Number<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="text" 
                                            v-model="formData.device_serial_no" 
                                            placeholder="Enter serial number" 
                                            :readonly="jobHasExistingCameraSerialData"
                                            required 
                                        />
                                        <span class="validate-error" v-if="errors.device_serial_no">
                                            {{ errors.device_serial_no[0] }}
                                        </span>
                                    </div>

                                    <!-- Camera Name (only for product_id = 2) -->
                                    <div class="col-md-3 form-group mb-3" v-if="job.product_id == 2">
                                        <label class="control-label">No of Cameras<span class="text-danger">*</span></label>
                                        <input
                                            class="form-control"
                                            type="number"
                                            placeholder="1–5"
                                            v-model="formData.no_of_cameras"
                                            min="1"
                                            :max="MAX_VISIBLE_CAMERAS"
                                            step="1"
                                            :readonly="isCameraCountLocked"
                                            @input="onNoOfCamerasInput"
                                        />
                                        <span class="validate-error" v-if="errors.no_of_cameras">
                                            {{ errors.no_of_cameras[0] }}
                                        </span>
                                    </div>

                                    <template v-if="job.product_id == 2 && visibleCameraFieldCount > 0">
                                    <div class="col-md-6 form-group mb-3" v-if="visibleCameraFieldCount >= 1">
                                        <label class="control-label">Camera Name<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="text" 
                                            v-model="formData.camera_name"
                                            placeholder="Enter camera name"
                                            :disabled="useDealerCameraSerialPicker || jobHasExistingCameraSerialData"
                                        />
                                        <span class="validate-error" v-if="errors.camera_name">
                                            {{ errors.camera_name[0] }}
                                        </span>
                                    </div>

                                        <div class="col-md-6 form-group mb-3" v-if="visibleCameraFieldCount >= 2">
                                            <label class="control-label">Camera 2<span class="text-danger">*</span></label>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="formData.camera_2"
                                                placeholder="Enter camera 2 name/serial"
                                                :disabled="useDealerCameraSerialPicker || jobHasExistingCameraSerialData"
                                            />
                                            <span class="validate-error" v-if="errors.camera_2">
                                                {{ errors.camera_2[0] }}
                                            </span>
                                        </div>

                                        <div class="col-md-6 form-group mb-3" v-if="visibleCameraFieldCount >= 3">
                                            <label class="control-label">Camera 3<span class="text-danger">*</span></label>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="formData.camera_3"
                                                placeholder="Enter camera 3 name/serial"
                                                :disabled="useDealerCameraSerialPicker || jobHasExistingCameraSerialData"
                                            />
                                            <span class="validate-error" v-if="errors.camera_3">
                                                {{ errors.camera_3[0] }}
                                            </span>
                                        </div>

                                        <div class="col-md-6 form-group mb-3" v-if="visibleCameraFieldCount >= 4">
                                            <label class="control-label">Camera 4<span class="text-danger">*</span></label>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="formData.camera_4"
                                                placeholder="Enter camera 4 name/serial"
                                                :disabled="useDealerCameraSerialPicker || jobHasExistingCameraSerialData"
                                            />
                                            <span class="validate-error" v-if="errors.camera_4">
                                                {{ errors.camera_4[0] }}
                                            </span>
                                        </div>

                                        <div class="col-md-6 form-group mb-3" v-if="visibleCameraFieldCount >= 5">
                                            <label class="control-label">Camera 5<span class="text-danger">*</span></label>
                                            <input
                                                class="form-control"
                                                type="text"
                                                v-model="formData.camera_5"
                                                placeholder="Enter camera 5 name/serial"
                                                :disabled="useDealerCameraSerialPicker || jobHasExistingCameraSerialData"
                                            />
                                            <span class="validate-error" v-if="errors.camera_5">
                                                {{ errors.camera_5[0] }}
                                            </span>
                                        </div>
                                    </template>

                                    <!-- Speed Governor Search (only for product_id = 3) -->
                                    <div class="row" v-if="job.product_id == 3">
                                        <div class="col-md-12 form-group mb-3">
                                            <label class="control-label">Speed Governor<span class="text-danger">*</span></label>
                                            <div class="position-relative speed-governor-dropdown">
                                                <input 
                                                    type="text" 
                                                    class="form-control" 
                                                    v-model="speedGovernorSearch"
                                                    @click="handleSpeedGovernorClick"
                                                    @input="filterSpeedGovernors"
                                                    @focus="handleSpeedGovernorClick"
                                                    placeholder="Search speed governor..."
                                                    required
                                                />
                                                <div v-if="showSpeedGovernorDropdown" class="dropdown-menu show w-100" style="max-height: 300px; overflow-y: auto;">
                                                    <div v-if="isLoadingSpeedGovernors" class="dropdown-item text-center">
                                                        <i class="bx bx-loader-alt bx-spin"></i> Loading...
                                                    </div>
                                                    <div v-else-if="filteredSpeedGovernors.length === 0" class="dropdown-item text-muted">
                                                        No speed governors found
                                                    </div>
                                                    <div 
                                                        v-else
                                                        v-for="sg in filteredSpeedGovernors" 
                                                        :key="sg.id"
                                                        class="dropdown-item cursor-pointer"
                                                        @click="selectSpeedGovernor(sg)"
                                                    >
                                                        <div class="fw-bold">{{ sg.vehicle_model }}</div>
                                                        <div v-if="sg.sg_model" class="text-muted small">{{ sg.sg_model }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="selectedSpeedGovernor" class="mt-2">
                                                <small class="text-success">
                                                    Selected: {{ selectedSpeedGovernor.vehicle_model }}
                                                    <span v-if="selectedSpeedGovernor.sg_model"> - {{ selectedSpeedGovernor.sg_model }}</span>
                                                </small>
                                            </div>
                                        </div>

                                        <!-- TAC and COP fields - only show after speed governor selection -->
                                        <div v-if="selectedSpeedGovernor && formData.tac_number" class="col-md-6 form-group mb-3">
                                            <label class="control-label">TAC Number</label>
                                            <input 
                                                class="form-control" 
                                                type="text" 
                                                v-model="formData.tac_number" 
                                                placeholder="TAC number" 
                                                readonly
                                            />
                                        </div>
                                        <div v-if="selectedSpeedGovernor && formData.cop_number" class="col-md-6 form-group mb-3">
                                            <label class="control-label">COP Number</label>
                                            <input 
                                                class="form-control" 
                                                type="text" 
                                                v-model="formData.cop_number" 
                                                placeholder="COP number" 
                                                readonly
                                            />
                                        </div>

                                    </div>

                                    <!-- RC Image -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">RC Image<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="file" 
                                            @change="handleFileUpload($event, 'rc_image')"
                                            accept="image/*"
                                            ref="rcImageInput"
                                        />
                                        <span class="validate-error" v-if="errors.rc_image">
                                            {{ errors.rc_image[0] }}
                                        </span>
                                        <div v-if="existingImages.rc_image" class="mt-2">
                                            <small class="text-muted">Current image:</small>
                                            <img :src="imageUrl + existingImages.rc_image" class="img-thumbnail ms-2" width="100" height="100" alt="RC Image">
                                        </div>
                                        <div v-if="formData.rc_image" class="mt-2">
                                            <small class="text-success">New image selected</small>
                                            <img :src="previewImages.rc_image" class="img-thumbnail ms-2" width="100" height="100" alt="RC Image Preview">
                                        </div>
                                    </div>

                                    <!-- Device Image -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Device Image<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="file" 
                                            @change="handleFileUpload($event, 'device_image')"
                                            accept="image/*"
                                            ref="deviceImageInput"
                                        />
                                        <span class="validate-error" v-if="errors.device_image">
                                            {{ errors.device_image[0] }}
                                        </span>
                                        <div v-if="existingImages.device_image" class="mt-2">
                                            <small class="text-muted">Current image:</small>
                                            <img :src="imageUrl + existingImages.device_image" class="img-thumbnail ms-2" width="100" height="100" alt="Device Image">
                                        </div>
                                        <div v-if="formData.device_image" class="mt-2">
                                            <small class="text-success">New image selected</small>
                                            <img :src="previewImages.device_image" class="img-thumbnail ms-2" width="100" height="100" alt="Device Image Preview">
                                        </div>
                                    </div>

                                    <!-- Captured Image (only for product_id = 2) -->
                                    <div class="col-md-6 form-group mb-3" v-if="showCapturedImageField">
                                        <label class="control-label">Captured Image<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="file" 
                                            @change="handleFileUpload($event, 'captured_images')"
                                            accept="image/*"
                                            ref="capturedImageInput"
                                        />
                                        <span class="validate-error" v-if="errors.captured_images">
                                            {{ errors.captured_images[0] }}
                                        </span>
                                        <div v-if="existingImages.captured_image" class="mt-2">
                                            <small class="text-muted">Current image:</small>
                                            <img :src="imageUrl + existingImages.captured_image" class="img-thumbnail ms-2" width="100" height="100" alt="Captured Image">
                                        </div>
                                        <div v-if="formData.captured_images" class="mt-2">
                                            <small class="text-success">New image selected</small>
                                            <img :src="previewImages.captured_images" class="img-thumbnail ms-2" width="100" height="100" alt="Captured Image Preview">
                                        </div>
                                    </div>

                                    <!-- Vehicle Image -->
                                    <div class="col-md-6 form-group mb-3">
                                        <label class="control-label">Vehicle Image<span class="text-danger">*</span></label>
                                        <input 
                                            class="form-control" 
                                            type="file" 
                                            @change="handleFileUpload($event, 'vehicle_image')"
                                            accept="image/*"
                                            ref="vehicleImageInput"
                                        />
                                        <span class="validate-error" v-if="errors.vehicle_image">
                                            {{ errors.vehicle_image[0] }}
                                        </span>
                                        <div v-if="existingImages.vehicle_image" class="mt-2">
                                            <small class="text-muted">Current image:</small>
                                            <img :src="imageUrl + existingImages.vehicle_image" class="img-thumbnail ms-2" width="100" height="100" alt="Vehicle Image">
                                        </div>
                                        <div v-if="formData.vehicle_image" class="mt-2">
                                            <small class="text-success">New image selected</small>
                                            <img :src="previewImages.vehicle_image" class="img-thumbnail ms-2" width="100" height="100" alt="Vehicle Image Preview">
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col-sm-12">
                                        <button class="btn btn-success me-2 float-end" type="submit">Mark Job as Completed</button>
                                    </div>
                                </div>
                            </form>


                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script setup>
    import { onMounted, onUnmounted, ref, getCurrentInstance, inject, computed, watch } from 'vue';
    import { useRouter, useRoute } from 'vue-router';
    import { get, post } from '@/utils/api';
    import { routes } from '@/constants/routes';
    import Swal from '@/utils/swal';
    import { goBack } from '@/utils/urlHider';
    import {
        DEALER_ROLE_ID,
        readStoredLoginDetails,
        parseSettingsDealerProfile,
        resolveAccountIdForAvailableDealerCameras,
        getDealerFormPrefillFromSettings,
        getDealerCameraNameFromRow,
        mapDealerCameraRowToFormFields,
        inferDealerCameraCountFromRow,
        parseVisibleCameraCount,
        resolveNoOfCamerasFromJob,
        trimCamerasOnTarget,
        applyMappedCamerasToTarget,
        validateVisibleCameraFields,
        MAX_VISIBLE_CAMERAS,
    } from '@/utils/dealerRole3Profile';
    
    // Define emit for parent component communication
    const emit = defineEmits(['completed']);

    const router = useRouter();
    const route = useRoute();
    const { proxy } = getCurrentInstance();
    const imageUrl = inject('imageUrl');

    const job_id = route.query.id;
    const job = ref({});

    const errors = ref({});

    // Form data
    const formData = ref({
        technician_id: '',
        vehicle_no: '',
        engine_no: '',
        chassis_no: '',
        vehicle_make: '',
        vehicle_model: '',
        registration_date: '',
        imei: '',
        device_serial_no: '',
        speed_governor_id: '',
        tac_number: '',
        cop_number: '',
        camera_name: '',
        camera_2: '',
        camera_3: '',
        camera_4: '',
        camera_5: '',
        no_of_cameras: '',
        rc_image: null,
        device_image: null,
        captured_images: null,
        vehicle_image: null
    });

    // Existing images from job
    const existingImages = ref({});

    // Preview images for new uploads
    const previewImages = ref({});

    // Loading state
    const isSubmitting = ref(false);

    // Technicians list
    const technicians = ref([]);

    // Dealer dropdown variables
    const dealer_id = ref('');
    const dealers = ref([]);
    const dealer_search = ref('');
    const showDealerSuggestions = ref(false);
    const dealerSuggestionList = ref(null);

    const user_role_id = ref(null);
    const settings_account_id = ref('');
    const settings_dealer_entity_id = ref('');
    const settings_dealer_label = ref('');
    const dealerCamerasList = ref([]);
    const showDealerCameraSuggestions = ref(false);
    const selectedDealerCameraRow = ref(null);

    // Speed Governor related variables
    const speedGovernors = ref([]);
    const filteredSpeedGovernors = ref([]);
    const speedGovernorSearch = ref('');
    const selectedSpeedGovernor = ref(null);
    const showSpeedGovernorDropdown = ref(false);
    const isLoadingSpeedGovernors = ref(false);

    // File input element refs (to clear native input values)
    const rcImageInput = ref(null);
    const deviceImageInput = ref(null);
    const capturedImageInput = ref(null);
    const vehicleImageInput = ref(null);

    // Computed properties for conditional fields
    const showImeiField = computed(() => {
        return job.value.product_id == 1 && (job.value.service_type == 1 || job.value.service_type == 3);
    });

    const showSerialNumberField = computed(() => {
        return job.value.product_id != 1 && job.value.service_type == 1;
    });

    const showCapturedImageField = computed(() => {
        return job.value.product_id == 2;
    });

    const isDealerProfileLocked = computed(
        () =>
            Number(user_role_id.value) === DEALER_ROLE_ID &&
            !!String(settings_dealer_entity_id.value || '').trim(),
    );

    const isDealerCameraSerialPicker = computed(
        () =>
            Number(user_role_id.value) === DEALER_ROLE_ID &&
            job.value.product_id == 2 &&
            showSerialNumberField.value,
    );

    /** Serial/camera already saved on the job (e.g. Complete Job Data modal) — no dealer list re-pick. */
    const jobHasExistingCameraSerialData = computed(() => {
        if (Number(job.value.product_id) !== 2 || !showSerialNumberField.value) return false;
        return String(job.value.device_serial_no || '').trim() !== '';
    });

    const useDealerCameraSerialPicker = computed(
        () => isDealerCameraSerialPicker.value && !jobHasExistingCameraSerialData.value,
    );

    const visibleCameraFieldCount = computed(() =>
        parseVisibleCameraCount(formData.value.no_of_cameras),
    );

    const isCameraCountLocked = computed(
        () => job.value.product_id == 2 && jobHasExistingCameraSerialData.value,
    );

    const filteredDealerCameras = computed(() => {
        const list = dealerCamerasList.value || [];
        const q = (formData.value.device_serial_no || '').trim().toLowerCase();
        if (!q) return list;
        return list.filter((r) => String(r.serial_number || '').toLowerCase().includes(q));
    });

    // Computed property for filtered Dealer list
    const filteredDealerList = computed(() => {
        if (!dealer_search.value || dealer_search.value.trim() === '') {
            return dealers.value;
        }
        const searchTerm = dealer_search.value.toLowerCase();
        return dealers.value.filter(dealer =>
            (dealer.first_name || '').toLowerCase().includes(searchTerm)
        );
    });

    // File upload handler
    const handleFileUpload = (event, fieldName) => {
        const file = event.target.files[0];
        if (file) {
            formData.value[fieldName] = file;
            
            // Create preview
            const reader = new FileReader();
            reader.onload = (e) => {
                previewImages.value[fieldName] = e.target.result;
            };
            reader.readAsDataURL(file);
        }
    };

    const fetchJob = () => {

        const params = {
            job_id: job_id
        }

        get(routes.JobDetail, { params }, false)
            .then((response) => {
                if(response.status === 200){
                    // console.log(response.data.data);
                    job.value = response.data.data.details;
                    console.log('Job data:', job.value);
                    initializeForm();
                } else {
                    Swal.fire('', response.data.message || 'Failed to fetch job', 'error');
                }
            })
            .catch((error)  => {
                if (error.response?.status === 422) {
                    Swal.fire('', error.response.data.message.job_id?.[0] || 'Validation error', 'error');
                } else if (error.response?.status === 500) {
                    Swal.fire('', error.response.statusText || 'Server error', 'error');
                } else if (error.response?.status === 401) {
                    Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                    router.push({ name: 'login' });
                } else {
                    Swal.fire('', error.response.data?.message || 'Error occured', 'error');
                }
            });
    };

    // Fetch technicians
    const fetchTechnicians = () => {
        get(routes.AllTechnicians, {}, false)
            .then((response) => {
                if (response.status === 200) {
                    console.log(response.data.data);
                    technicians.value = response.data.data;
                } else {
                    Swal.fire('Error', response.data.message || 'Error fetching technicians', 'error');
                }
            })
            .catch((error) => {
                if (error.response?.status === 422) {
                    Swal.fire('Validation Error', 'Please check your input data', 'error');
                } else if (error.response?.status === 500) {
                    Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
                } else if (error.response?.status === 401) {
                    Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
                    router.push({ name: 'login' });
                } else {
                    Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
                }
            });
    };

    const prefillDealerFromId = () => {
        if (!dealer_id.value) return;
        if (dealer_search.value && dealer_search.value.trim() !== '') return;
        const match = dealers.value.find(d => String(d.id) === String(dealer_id.value));
        if (match) {
            dealer_search.value = [match.first_name, match.last_name].filter(Boolean).join(' ').trim() || match.first_name || '';
        }
    };

    const applyLockedDealerFromSettings = () => {
        if (!isDealerProfileLocked.value || !settings_dealer_entity_id.value) return;
        dealer_id.value = settings_dealer_entity_id.value;
        if (settings_dealer_label.value) {
            dealer_search.value = settings_dealer_label.value;
        }
    };

    const fetchAvailableDealerCameras = () => {
        const did = resolveAccountIdForAvailableDealerCameras(settings_account_id.value);
        if (!did) return;
        get(routes.AvailableDealerCameras, { params: { dealer_id: did } }, false)
            .then((response) => {
                if (response.status === 200) {
                    dealerCamerasList.value = response.data.data?.dealer_camera ?? [];
                }
            })
            .catch(() => {});
    };

    const stripDealerCameraSelection = () => {
        selectedDealerCameraRow.value = null;
        formData.value.camera_name = '';
        formData.value.camera_2 = '';
        formData.value.camera_3 = '';
        formData.value.camera_4 = '';
        formData.value.camera_5 = '';
        formData.value.no_of_cameras = '';
    };

    const onNoOfCamerasInput = () => {
        const raw = String(formData.value.no_of_cameras ?? '').trim();
        if (raw === '') {
            trimCamerasOnTarget(formData.value, 0);
            return;
        }
        let n = parseInt(raw, 10);
        if (Number.isNaN(n) || n < 1) {
            formData.value.no_of_cameras = '';
            trimCamerasOnTarget(formData.value, 0);
            return;
        }
        if (n > MAX_VISIBLE_CAMERAS) {
            n = MAX_VISIBLE_CAMERAS;
            formData.value.no_of_cameras = String(MAX_VISIBLE_CAMERAS);
        }
        if (selectedDealerCameraRow.value) {
            const count = applyMappedCamerasToTarget(formData.value, selectedDealerCameraRow.value, n);
            formData.value.no_of_cameras = String(count);
        } else {
            trimCamerasOnTarget(formData.value, n);
        }
    };

    const selectDealerCamera = (row) => {
        selectedDealerCameraRow.value = row;
        formData.value.device_serial_no = row.serial_number || '';
        let count = inferDealerCameraCountFromRow(row);
        const manualCount = parseInt(String(formData.value.no_of_cameras ?? '').trim(), 10);
        if (!count && !Number.isNaN(manualCount) && manualCount >= 1) {
            count = Math.min(MAX_VISIBLE_CAMERAS, manualCount);
        }
        if (!count) count = 1;
        formData.value.no_of_cameras = String(count);
        applyMappedCamerasToTarget(formData.value, row, count);
        showDealerCameraSuggestions.value = false;
    };

    const tryMatchDealerCameraBySerial = () => {
        const sn = String(formData.value.device_serial_no ?? '').trim();
        if (!sn || !useDealerCameraSerialPicker.value) return;
        const row = dealerCamerasList.value.find(
            (r) => String(r.serial_number ?? '').trim() === sn,
        );
        if (row) selectDealerCamera(row);
    };

    const onDealerCameraSerialInput = () => {
        if (selectedDealerCameraRow.value) {
            const sel = selectedDealerCameraRow.value.serial_number;
            if (String(formData.value.device_serial_no ?? '').trim() !== String(sel ?? '').trim()) {
                stripDealerCameraSelection();
            }
        }
        if (formData.value.device_serial_no && formData.value.device_serial_no.trim() !== '') {
            showDealerCameraSuggestions.value = true;
        } else {
            showDealerCameraSuggestions.value = false;
        }
    };

    const onDealerCameraSerialFocus = () => {
        if (dealerCamerasList.value.length) {
            showDealerCameraSuggestions.value = true;
        }
    };

    const onDealerCameraSerialBlur = () => {
        setTimeout(() => {
            showDealerCameraSuggestions.value = false;
            tryMatchDealerCameraBySerial();
        }, 200);
    };

    const setCameraFieldsFromJob = () => {
        if (job.value.product_id != 2) {
            formData.value.no_of_cameras = '';
            return;
        }
        formData.value.camera_name = job.value.camera_name || job.value.camera || '';
        formData.value.camera_2 = job.value.camera_2 || '';
        formData.value.camera_3 = job.value.camera_3 || '';
        formData.value.camera_4 = job.value.camera_4 || '';
        formData.value.camera_5 = job.value.camera_5 || '';
        formData.value.no_of_cameras = resolveNoOfCamerasFromJob(job.value);
    };

    const fetchUserSettings = () =>
        get(routes.Settings, {}, false)
            .then((response) => {
                if (response.status === 200 && response.data?.data) {
                    const d = response.data.data;
                    const p = parseSettingsDealerProfile(d);
                    user_role_id.value = p.roleId;
                    settings_account_id.value = p.accountId;
                    settings_dealer_entity_id.value = p.dealerEntityId;
                    settings_dealer_label.value = p.displayName;
                    const prefill = getDealerFormPrefillFromSettings(d);
                    if (prefill) {
                        dealer_id.value = prefill.dealerId;
                        dealer_search.value = prefill.displayName;
                    }
                    if (useDealerCameraSerialPicker.value) {
                        fetchAvailableDealerCameras();
                    }
                }
            })
            .catch(() => {});

    watch(useDealerCameraSerialPicker, (on) => {
        if (on && resolveAccountIdForAvailableDealerCameras(settings_account_id.value)) {
            fetchAvailableDealerCameras();
        }
        if (!on) {
            selectedDealerCameraRow.value = null;
            showDealerCameraSuggestions.value = false;
        }
    });

    const fetchDealers = () => {
        get(routes.getDealers, {}, false)
            .then((response) => {
                if (response.status === 200) {
                    dealers.value = response.data.data || [];
                    prefillDealerFromId();
                } else {
                    Swal.fire('Error', response.data.message || 'Error fetching dealers', 'error');
                }
            })
            .catch((error) => {
                if (error.response?.status === 422) {
                    Swal.fire('Validation Error', 'Please check your input data', 'error');
                } else if (error.response?.status === 500) {
                    Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
                } else if (error.response?.status === 401) {
                    Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
                    router.push({ name: 'login' });
                } else {
                    Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
                }
            });
    };

    // Initialize form with job data
    const initializeForm = () => {
        formData.value.technician_id = job.value.technician_id || '';
        formData.value.vehicle_no = job.value.vehicle_no || '';
        formData.value.engine_no = job.value.engine_no || '';
        formData.value.chassis_no = job.value.chassis_no || '';
        formData.value.vehicle_make = job.value.vehicle_make || '';
        formData.value.vehicle_model = job.value.vehicle_model || '';
        formData.value.registration_date = job.value.registration_date || '';
        // formData.value.imei = job.value.imei || '';
        formData.value.device_serial_no = job.value.device_serial_no || '';
        formData.value.speed_governor_id = job.value.speed_governor_id || '';
        formData.value.tac_number = job.value.tac_number || '';
        formData.value.cop_number = job.value.cop_number || '';
        setCameraFieldsFromJob();

        // Set existing images
        existingImages.value = job.value.images || {};
        
        // Clear previous uploads
        formData.value.rc_image = null;
        formData.value.device_image = null;
        formData.value.captured_images = null;
        formData.value.vehicle_image = null;
        
        previewImages.value = {};
        
        // Initialize speed governor if exists
        if (job.value.speed_governor_id && job.value.speed_governor) {
            selectedSpeedGovernor.value = job.value.speed_governor;
            speedGovernorSearch.value = job.value.speed_governor.sg_model ? 
                `${job.value.speed_governor.vehicle_model} - ${job.value.speed_governor.sg_model}` : 
                job.value.speed_governor.vehicle_model;
        }

        // Initialize dealer if exists
        dealer_id.value = job.value.dealer_id || '';
        if (job.value.dealer) {
            dealer_search.value = [job.value.dealer.first_name, job.value.dealer.last_name].filter(Boolean).join(' ').trim() || job.value.dealer.first_name || '';
        } else {
            dealer_search.value = '';
            prefillDealerFromId();
        }
        applyLockedDealerFromSettings();
        prefillDealerFromId();
        selectedDealerCameraRow.value = null;
        showDealerCameraSuggestions.value = false;
    };

    // Clear form function - reset to original job data
    const clearForm = () => {
        // Reset to original job data (auto-filled fields)
        formData.value.technician_id = job.value.technician_id || '';
        formData.value.vehicle_no = job.value.vehicle_no || '';
        formData.value.engine_no = job.value.engine_no || '';
        formData.value.chassis_no = job.value.chassis_no || '';
        formData.value.vehicle_make = job.value.vehicle_make || '';
        formData.value.vehicle_model = job.value.vehicle_model || '';
        formData.value.registration_date = job.value.registration_date || '';
        // formData.value.imei = job.value.imei || '';
        formData.value.device_serial_no = job.value.device_serial_no || '';
        formData.value.speed_governor_id = job.value.speed_governor_id || '';
        formData.value.tac_number = job.value.tac_number || '';
        formData.value.cop_number = job.value.cop_number || '';
        setCameraFieldsFromJob();

        // Clear only the new file uploads (keep existing images)
        formData.value.rc_image = null;
        formData.value.device_image = null;
        formData.value.captured_images = null;
        formData.value.vehicle_image = null;
        
        // Clear preview images (new uploads)
        previewImages.value = {};
        
        // Keep existing images from job data
        existingImages.value = job.value.images || {};
        
        // Reset speed governor
        selectedSpeedGovernor.value = null;
        speedGovernorSearch.value = '';
        showSpeedGovernorDropdown.value = false;

        // Reset dealer to original job data
        dealer_id.value = job.value.dealer_id || '';
        if (job.value.dealer) {
            dealer_search.value = [job.value.dealer.first_name, job.value.dealer.last_name].filter(Boolean).join(' ').trim() || job.value.dealer.first_name || '';
        } else {
            dealer_search.value = '';
            prefillDealerFromId();
        }
        applyLockedDealerFromSettings();
        prefillDealerFromId();
        selectedDealerCameraRow.value = null;
        showDealerCameraSuggestions.value = false;
        showDealerSuggestions.value = false;
        
        // Clear native file input elements so chosen filenames disappear
        if (rcImageInput.value) rcImageInput.value.value = '';
        if (deviceImageInput.value) deviceImageInput.value.value = '';
        if (capturedImageInput.value) capturedImageInput.value.value = '';
        if (vehicleImageInput.value) vehicleImageInput.value.value = '';
    };

    // Fetch speed governors (lazy loading)
    const fetchSpeedGovernors = () => {
        if (speedGovernors.value.length > 0) {
            // Data already loaded
            return;
        }

        isLoadingSpeedGovernors.value = true;
        get(routes.getSpeedGovernorData, {}, false)
            .then((response) => {
                if (response.status === 200) {
                    console.log('Speed governors API response:', response.data);
                    console.log('Speed governors data:', response.data.data);
                    
                    // Handle different possible response structures
                    let data = response.data.data;
                    if (Array.isArray(data)) {
                        speedGovernors.value = data;
                        filteredSpeedGovernors.value = data;
                    } else if (data && Array.isArray(data.data)) {
                        speedGovernors.value = data.data;
                        filteredSpeedGovernors.value = data.data;
                    } else if (data && Array.isArray(data.speedGovernors)) {
                        // Handle the actual API response structure
                        speedGovernors.value = data.speedGovernors;
                        filteredSpeedGovernors.value = data.speedGovernors;
                    } else {
                        console.error('Unexpected data structure:', data);
                        speedGovernors.value = [];
                        filteredSpeedGovernors.value = [];
                    }
                } else {
                    Swal.fire('Error', response.data.message || 'Error fetching speed governors', 'error');
                }
            })
            .catch((error) => {
                if (error.response?.status === 422) {
                    Swal.fire('Validation Error', 'Please check your input data', 'error');
                } else if (error.response?.status === 500) {
                    Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
                } else if (error.response?.status === 401) {
                    Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
                    router.push({ name: 'login' });
                } else {
                    Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
                }
            })
            .finally(() => {
                isLoadingSpeedGovernors.value = false;
            });
    };

    // Handle speed governor input click/focus
    const handleSpeedGovernorClick = () => {
        showSpeedGovernorDropdown.value = true;
        fetchSpeedGovernors(); // Load data only when clicked
    };

    // Filter speed governors based on search
    const filterSpeedGovernors = () => {
        // Don't filter if data hasn't loaded yet
        if (isLoadingSpeedGovernors.value) {
            return;
        }

        // Check if speedGovernors is an array and has data
        if (!Array.isArray(speedGovernors.value) || speedGovernors.value.length === 0) {
            filteredSpeedGovernors.value = [];
            return;
        }

        if (!speedGovernorSearch.value.trim()) {
            filteredSpeedGovernors.value = speedGovernors.value;
            return;
        }

        const searchTerm = speedGovernorSearch.value.toLowerCase();
        filteredSpeedGovernors.value = speedGovernors.value.filter(sg => {
            const vehicleModel = sg.vehicle_model?.toLowerCase() || '';
            const sgModel = sg.sg_model?.toLowerCase() || '';
            return vehicleModel.includes(searchTerm) || sgModel.includes(searchTerm);
        });
    };

    // Select speed governor
    const selectSpeedGovernor = (sg) => {
        selectedSpeedGovernor.value = sg;
        formData.value.speed_governor_id = sg.id;
        speedGovernorSearch.value = sg.sg_model ? `${sg.vehicle_model} - ${sg.sg_model}` : sg.vehicle_model;
        showSpeedGovernorDropdown.value = false;
        
        // Fetch speed governor details to populate TAC and COP numbers
        fetchSpeedGovernorDetails(sg.id);
    };

    // Fetch speed governor details
    const fetchSpeedGovernorDetails = (sgId) => {
        const params = {
            id: sgId
        };

        get(routes.speedGovernorDetails, { params }, false)
            .then((response) => {
                if (response.status === 200) {
                    console.log('Speed governor details:', response.data.data);
                    const details = response.data.data;
                    
                    // Populate TAC and COP number fields
                    formData.value.tac_number = details.sg_tac_number || '';
                    formData.value.cop_number = details.cop_number || '';
                } else {
                    console.error('Failed to fetch speed governor details:', response.data.message);
                }
            })
            .catch((error) => {
                console.error('Error fetching speed governor details:', error);
                if (error.response?.status === 401) {
                    Swal.fire('Unauthorized', 'Please login again', 'error');
                    router.push({ name: 'login' });
                }
            });
    };


    // Submit completion
    const submitCompletion = async () => {
        // Clear previous errors
        errors.value = {};

        // Validation
        if (!formData.value.technician_id) {
            errors.value.technician_id = ['Please select a technician'];
            Swal.fire('Validation Error', 'Please select a technician', 'error');
            return;
        }

        if (!formData.value.vehicle_no.trim()) {
            errors.value.vehicle_no = ['Please enter vehicle number'];
            Swal.fire('Validation Error', 'Please enter vehicle number', 'error');
            return;
        }

        if (showImeiField.value && !formData.value.imei.trim()) {
            errors.value.imei = ['Please enter IMEI number'];
            Swal.fire('Validation Error', 'Please enter IMEI number', 'error');
            return;
        }

        if (showSerialNumberField.value && !formData.value.device_serial_no.trim()) {
            errors.value.device_serial_no = ['Please enter serial number'];
            Swal.fire('Validation Error', 'Please enter serial number', 'error');
            return;
        }

        if (job.value.product_id == 2) {
            const cameraErr = validateVisibleCameraFields(formData.value, formData.value.no_of_cameras);
            if (cameraErr) {
                Swal.fire('Validation Error', cameraErr, 'error');
                return;
            }
        }

        if (useDealerCameraSerialPicker.value) {
            if (!selectedDealerCameraRow.value || !formData.value.device_serial_no.trim()) {
                Swal.fire(
                    'Validation Error',
                    'Please search and select a serial number from your dealer camera list',
                    'error',
                );
                return;
            }
            if (
                String(formData.value.device_serial_no).trim() !==
                String(selectedDealerCameraRow.value.serial_number ?? '').trim()
            ) {
                Swal.fire('Validation Error', 'Serial number must match the selected camera row', 'error');
                return;
            }
        }

        if (job.value.product_id == 3 && !formData.value.speed_governor_id) {
            errors.value.speed_governor_id = ['Please select a speed governor'];
            Swal.fire('Validation Error', 'Please select a speed governor', 'error');
            return;
        }

        // Check if at least one image is uploaded or exists
        const hasRcImage = formData.value.rc_image || existingImages.value.rc_image;
        const hasDeviceImage = formData.value.device_image || existingImages.value.device_image;
        const hasVehicleImage = formData.value.vehicle_image || existingImages.value.vehicle_image;
        
        // For captured image, only require it if it's a new upload (not existing)
        const hasCapturedImage = !showCapturedImageField.value || formData.value.captured_images || existingImages.value.captured_image;

        if (!hasRcImage || !hasDeviceImage || !hasVehicleImage || !hasCapturedImage) {
            let missingImages = [];
            if (!hasRcImage) missingImages.push('RC Image');
            if (!hasDeviceImage) missingImages.push('Device Image');
            if (!hasVehicleImage) missingImages.push('Vehicle Image');
            if (!hasCapturedImage) missingImages.push('Captured Image');
            
            Swal.fire('Validation Error', `Please upload all required images: ${missingImages.join(', ')}`, 'error');
            return;
        }

        isSubmitting.value = true;

        try {
            // Prepare form data
            const submitData = new FormData();
            submitData.append('job_id', job_id);
            submitData.append('technician_id', formData.value.technician_id);
            submitData.append('dealer_id', dealer_id.value || '');
            submitData.append('vehicle_no', formData.value.vehicle_no);
            submitData.append('engine_no', formData.value.engine_no || '');
            submitData.append('chassis_no', formData.value.chassis_no || '');
            submitData.append('vehicle_make', formData.value.vehicle_make || '');
            submitData.append('vehicle_model', formData.value.vehicle_model || '');
            submitData.append('registration_date', formData.value.registration_date || '');

            if (job.value.product_id == 2) {
                submitData.append('camera_name', formData.value.camera_name || '');
                submitData.append('camera_2', formData.value.camera_2 || '');
                submitData.append('camera_3', formData.value.camera_3 || '');
                submitData.append('camera_4', formData.value.camera_4 || '');
                submitData.append('camera_5', formData.value.camera_5 || '');
                submitData.append('no_of_cameras', formData.value.no_of_cameras);
                if (useDealerCameraSerialPicker.value && selectedDealerCameraRow.value?.id != null) {
                    submitData.append('camera_id', selectedDealerCameraRow.value.id);
                } else if (
                    job.value.camera_id != null &&
                    job.value.camera_id !== '' &&
                    jobHasExistingCameraSerialData.value
                ) {
                    submitData.append('camera_id', job.value.camera_id);
                }
            }
            
            if (showImeiField.value) {
                submitData.append('imei', formData.value.imei);
            }
            
            if (showSerialNumberField.value) {
                submitData.append('serial_number', formData.value.device_serial_no);
            }

            if (job.value.product_id == 3) {
                submitData.append('speed_governor_id', formData.value.speed_governor_id);
                if (formData.value.tac_number) {
                    submitData.append('tac_number', formData.value.tac_number);
                }
                if (formData.value.cop_number) {
                    submitData.append('cop_number', formData.value.cop_number);
                }
            }

            // Append images only if new uploads exist (skip if only existing images)
            // RC Image
            if (formData.value.rc_image) {
                submitData.append('rc_image', formData.value.rc_image);
            }
            
            // Device Image
            if (formData.value.device_image) {
                submitData.append('device_image', formData.value.device_image);
            }
            
            // Captured Images (only for product_id = 2)
            if (job.value.product_id == 2 && formData.value.captured_images) {
                submitData.append('captured_images', formData.value.captured_images);
            }
            
            // Vehicle Image
            if (formData.value.vehicle_image) {
                submitData.append('vehicle_image', formData.value.vehicle_image);
            }

		    post(routes.MarkAsDone, submitData, false)
                .then((response) => {
                    if (response.status === 200) {
                        Swal.fire('', response.data.message || 'Job marked as completed successfully', 'success');
                        router.push({ name: 'job_management'});
                    } else {
                        Swal.fire('', response.data.message || 'Failed to mark job as completed', 'error');
                    }
                })
                .catch((error) => {
                    if (error.response?.status === 422) {
                        // Handle validation errors - message can be string or object
                        const message = error.response.data.message;
                        
                        if (typeof message === 'string') {
                            // If message is a string, show it directly
                            errors.value = {};
                            Swal.fire('Validation Error', message, 'error');
                        } else if (typeof message === 'object' && message !== null) {
                            // If message is an object with field errors
                            errors.value = message;
                            
                            // Show SweetAlert with validation errors
                            let errorMessages = [];
                            Object.keys(message).forEach(field => {
                                if (Array.isArray(message[field])) {
                                    errorMessages.push(`${field}: ${message[field].join(', ')}`);
                                } else {
                                    errorMessages.push(`${field}: ${message[field]}`);
                                }
                            });
                            Swal.fire('Validation Error', errorMessages.join('<br>'), 'error');
                        } else {
                            errors.value = {};
                            Swal.fire('Validation Error', 'Validation failed', 'error');
                        }
                    } else if (error.response?.status === 500) {
                        Swal.fire('Server Error', error.response.statusText || 'Server error occurred', 'error');
                    } else if (error.response?.status === 401) {
                        Swal.fire('Unauthorized', error.response.statusText || 'Please login again', 'error');
                        router.push({ name: 'login' });
                    } else {
                        Swal.fire('Error', error.response.data?.message || 'An error occurred', 'error');
                    }
                });
            
            console.log('Form cleared');
            clearForm(); // Clear form on error
        } finally {
            console.log('Submitting state reset');
            isSubmitting.value = false;
        }
    };

    // Initialize on mount
    onMounted(() => {
        const ls = readStoredLoginDetails();
        if (ls) {
            const p = parseSettingsDealerProfile(ls);
            if (p.roleId != null) user_role_id.value = p.roleId;
            if (p.accountId) settings_account_id.value = p.accountId;
            if (p.dealerEntityId) settings_dealer_entity_id.value = p.dealerEntityId;
            if (p.displayName) settings_dealer_label.value = p.displayName;
        }
        fetchUserSettings().finally(() => {
            fetchTechnicians();
            fetchDealers();
            fetchJob();
        });
        document.addEventListener('click', handleClickOutside);
    });

    const handleClickOutside = (event) => {
        const speedGovDropdown = document.querySelector('.speed-governor-dropdown');
        if (speedGovDropdown && !speedGovDropdown.contains(event.target)) {
            showSpeedGovernorDropdown.value = false;
        }

        const dealerDropdown = document.querySelector('.dealer-dropdown');
        const dealerCameraDropdown = event.target.closest('.dealer-camera-dropdown');
        if (dealerDropdown && !dealerDropdown.contains(event.target) && !dealerCameraDropdown) {
            showDealerSuggestions.value = false;
        }
        if (!dealerCameraDropdown) {
            showDealerCameraSuggestions.value = false;
        }
    };

    onUnmounted(() => {
        document.removeEventListener('click', handleClickOutside);
    });

    // Dealer dropdown handlers
    const handleDealerSearch = () => {
        if (isDealerProfileLocked.value) return;
        if (dealer_search.value && dealer_search.value.trim() !== '') {
            showDealerSuggestions.value = true;
        } else {
            showDealerSuggestions.value = false;
            if (!dealer_search.value || dealer_search.value.trim() === '') {
                dealer_id.value = '';
            }
        }
    };

    const handleDealerInputBlur = () => {
        setTimeout(() => {
            showDealerSuggestions.value = false;
        }, 200);
    };

    const setDealer = (dealer) => {
        if (isDealerProfileLocked.value) return;
        dealer_search.value = dealer.first_name || '';
        dealer_id.value = dealer.id;
        showDealerSuggestions.value = false;
    };

    // Expose methods
    defineExpose({
        clearForm
    });

	const handleGoBack = () => {
		const success = goBack(router);
		if (!success) {
			// If no history, go to dashboard as fallback
			router.push({ name: 'defaultRoot' });
		}
	};

</script>

<style scoped>
.img-thumbnail {
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
}

.text-success {
    color: #198754 !important;
}

.text-muted {
    color: #6c757d !important;
}

.cursor-pointer {
    cursor: pointer;
}

.dropdown-menu.show {
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    min-width: 100%;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.15);
    border-radius: 0.375rem;
    box-shadow: 0 0.5rem 1rem rgba(0,0,0,.175);
}

.dropdown-item {
    display: block;
    width: 100%;
    padding: 0.25rem 1rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    text-decoration: none;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
}

.dropdown-item:hover {
    color: #1e2125;
    background-color: #e9ecef;
}

.dropdown-item:focus {
    color: #1e2125;
    background-color: #e9ecef;
}

.bx-spin {
    animation: bx-spin 1s linear infinite;
}

@keyframes bx-spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
